import { connect } from "react-redux";
import buildForm from "../library/forms/buildForm";
import AnnotationForm from "./AnnotationForm";
import { upsertAnnotation } from "../../processes/annotationProcesses";

const form = buildForm("annotationForm");

function mapStateToProps(state, { annotation }) {
  return {
    initialValues: {
      courseId: state.currentCourseId,
      lessonId: state.currentLessonId,
      videoTime: state.lesson.currentTime,
      ...annotation,
    },
  };
}

export default connect(mapStateToProps)(
  form.connect({
    onSubmit: upsertAnnotation,
  })(AnnotationForm)
);
